import {
  CircularProgress,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { Inline, Stack, Tag } from '@superdispatch/ui';
import { FloatingButtonArea } from 'shared/ui/FloatingButtonArea';
import { SuggestedDriverDTO } from '../data/SuggestedDriversDTO';

interface SuggestedDriverItemProps {
  suggestion: SuggestedDriverDTO;
  onClick: () => void;
  isSubmitting: boolean;
  selectedGUID: string | undefined;
}

export function SuggestedDriverItem({
  suggestion,
  onClick,
  isSubmitting,
  selectedGUID,
}: SuggestedDriverItemProps) {
  const { driver, reasons } = suggestion;
  const isSelected = driver.guid === selectedGUID;
  const isLoading = isSelected && isSubmitting;

  return (
    <ListItem
      button={true}
      aria-label="Suggested Driver"
      disabled={isSubmitting}
      onClick={onClick}
    >
      <FloatingButtonArea
        buttonPlacement="right"
        buttonVisible={isLoading}
        button={
          <Typography variant="body1" color="primary" component="div">
            {isLoading ? <CircularProgress size="1em" /> : 'Assign'}
          </Typography>
        }
      >
        <ListItemText
          disableTypography={true}
          primary={
            <Inline space="xsmall" verticalAlign="center">
              <Typography variant="h4">{driver.name}</Typography>
              {!!driver.truck_size && (
                <Tag variant="subtle" color="grey">
                  {driver.truck_size} vehicle trailer
                </Tag>
              )}
            </Inline>
          }
          secondary={
            <Stack space="none">
              {reasons.map((reason) => (
                <Typography key={reason} color="textSecondary">
                  {reason}
                </Typography>
              ))}
            </Stack>
          }
        />
      </FloatingButtonArea>
    </ListItem>
  );
}
